import { ContentModal } from 'features/modals';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from 'utils';

import { Login } from '../components/Login';
import { Register } from '../components/Register';

export const AuthRoutes = ({ isEnabled } : { isEnabled: boolean }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as {
    backgroundLocation?: Location;
  };

  // [!state?.backgroundLocation] prevents the auth routes from being rendered if someone visits the url directly. They are only opened on top of another route when the state.backgroundLocation is set
  // [!isEnabled] prevents auth routes from being enabled when app and/or voting are closed.
  if (!state?.backgroundLocation || !isEnabled) return null;

  return (
    <Routes>
      <Route
        path={ROUTES.LOGIN}
        element={
          <ContentModal isOpen onClose={() => navigate(state.backgroundLocation!, { replace: true })}>
            <Login />
          </ContentModal>
        }
      />
      <Route
        path={ROUTES.REGISTER}
        element={
          <ContentModal isOpen onClose={() => navigate(state.backgroundLocation!, { replace: true })}>
            <Register />
          </ContentModal>
        }
      />
    </Routes>
  );
};
